export default "__VITE_ASSET__4be70578__"